"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import ArtistPreviewAppWrapper from "./ArtistPreviewAppWrapper";
import { ArtistPreviewModalContent } from "./ArtistPreviewModalContent";
export type ModalTab = "active" | "winners";
interface ArtistPreviewModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly user: ApiProfileMin;
  readonly initialTab?: ModalTab;
}
export const ArtistPreviewModal: React.FC<ArtistPreviewModalProps> = t0 => {
  const $ = _c(42);
  const {
    isOpen,
    onClose,
    user,
    initialTab: t1
  } = t0;
  const initialTab = t1 === undefined ? "active" : t1;
  const {
    isApp
  } = useDeviceInfo();
  const modalRef = useRef(null);
  const previousFocusRef = useRef(null);
  const [activeTab, setActiveTab] = useState(initialTab);
  const hasWinningArtworks = user.winner_main_stage_drop_ids && user.winner_main_stage_drop_ids.length > 0;
  let t2;
  let t3;
  if ($[0] !== initialTab || $[1] !== isOpen) {
    t2 = () => {
      if (isOpen) {
        setActiveTab(initialTab);
      }
    };
    t3 = [isOpen, initialTab];
    $[0] = initialTab;
    $[1] = isOpen;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== isApp || $[5] !== isOpen) {
    t4 = () => {
      if (isOpen && !isApp) {
        previousFocusRef.current = document.activeElement as HTMLElement;
        document.body.style.overflow = "hidden";
        setTimeout(() => {
          modalRef.current?.focus();
        }, 100);
        return () => {
          document.body.style.overflow = "unset";
          previousFocusRef.current?.focus();
        };
      }
    };
    t5 = [isOpen, isApp];
    $[4] = isApp;
    $[5] = isOpen;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  if (!isOpen) {
    return null;
  }
  if (isApp) {
    let t6;
    if ($[8] !== activeTab || $[9] !== hasWinningArtworks || $[10] !== isOpen || $[11] !== onClose || $[12] !== user) {
      t6 = <ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={true} activeTab={activeTab} onTabChange={setActiveTab} hasWinningArtworks={hasWinningArtworks} />;
      $[8] = activeTab;
      $[9] = hasWinningArtworks;
      $[10] = isOpen;
      $[11] = onClose;
      $[12] = user;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== isOpen || $[15] !== onClose || $[16] !== t6) {
      t7 = <ArtistPreviewAppWrapper isOpen={isOpen} onClose={onClose}>{t6}</ArtistPreviewAppWrapper>;
      $[14] = isOpen;
      $[15] = onClose;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  let t6;
  if ($[18] !== onClose) {
    t6 = <Transition.Child as={Fragment} enter="tw-ease-out tw-duration-200" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in tw-duration-200" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px]" onClick={onClose} /></Transition.Child>;
    $[18] = onClose;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== activeTab || $[21] !== hasWinningArtworks || $[22] !== isOpen || $[23] !== onClose || $[24] !== user) {
    t7 = <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4"><Transition.Child as={Fragment} enter="tw-duration-0" enterFrom="tw-opacity-100" enterTo="tw-opacity-100" leave="tw-duration-0" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-100"><Dialog.Panel className="tw-relative tw-w-full tw-max-w-5xl tw-max-h-[90vh] tw-rounded-xl tw-bg-iron-950 tw-border tw-border-iron-800 tw-overflow-hidden tw-shadow-2xl tw-shadow-black/25 tw-m-0 tw-p-0" onClick={_temp2}><ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} activeTab={activeTab} onTabChange={setActiveTab} hasWinningArtworks={hasWinningArtworks} /></Dialog.Panel></Transition.Child></div>;
    $[20] = activeTab;
    $[21] = hasWinningArtworks;
    $[22] = isOpen;
    $[23] = onClose;
    $[24] = user;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== onClose || $[27] !== t7) {
    t8 = <div className="tw-fixed tw-inset-0 tw-z-[100] tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-hidden sm:tw-block" onClick={onClose}>{t7}</div>;
    $[26] = onClose;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== activeTab || $[30] !== hasWinningArtworks || $[31] !== isOpen || $[32] !== onClose || $[33] !== user) {
    t9 = <div className="tw-fixed tw-inset-0 tw-overflow-hidden tw-block sm:tw-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><Transition.Child as={Fragment} enter="tw-transform tw-transition tw-ease-out tw-duration-300" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-ease-in tw-duration-300" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><Dialog.Panel className="tw-pointer-events-auto tw-relative tw-w-screen tw-max-h-[90vh] tw-rounded-t-xl tw-bg-iron-950 tw-border-t tw-border-iron-800 tw-overflow-hidden tw-shadow-2xl tw-shadow-black/25"><ArtistPreviewModalContent user={user} isOpen={isOpen} onClose={onClose} isApp={false} activeTab={activeTab} onTabChange={setActiveTab} hasWinningArtworks={hasWinningArtworks} /></Dialog.Panel></Transition.Child></div></div></div>;
    $[29] = activeTab;
    $[30] = hasWinningArtworks;
    $[31] = isOpen;
    $[32] = onClose;
    $[33] = user;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== t6 || $[36] !== t8 || $[37] !== t9) {
    t10 = <Dialog as="div" className="tw-cursor-default tw-relative tw-z-[9999]" onClose={_temp}>{t6}{t8}{t9}</Dialog>;
    $[35] = t6;
    $[36] = t8;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== isOpen || $[40] !== t10) {
    t11 = createPortal(<Transition.Root show={isOpen} as={Fragment}>{t10}</Transition.Root>, document.body);
    $[39] = isOpen;
    $[40] = t10;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
};
function _temp() {}
function _temp2(e) {
  return e.stopPropagation();
}